module.exports = __webpack_public_path__ + "static/media/GBR Care (CBN Network) - GBR Care - 16-05-2024 C.1c28843b.gif";